"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 85: VRC7
 *
 * The FM synth is not implemented, so VRC7 games run silent. Banking is
 * complete, which is enough for the playfield.
 * ------------------------------------------------------------------ */
// VRC7 (partial: banking only, no YM2413)

function register(Mappers) {
  Mappers[85] = function (nes) {
    this.nes = nes;
  };

  Mappers[85].prototype = new Mappers[0]();

  Mappers[85].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);
    this.prgBank16 = [0, 0];
    this.chrBank8k = [0, 0];
  };

  Mappers[85].prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    switch (address & 0xf000) {
      case 0x8000:
        this.chrBank8k[0] = value & 0x0f;
        this.load8kVromBank(this.chrBank8k[0] * 2, 0x0000);
        this.nes.papu.exWrite(address, value);
        break;

      case 0x9000:
        if ((address & 0xff) === 0x00) {
          this.prgBank16[0] = value & 0x0f;
          this.loadRomBank(this.prgBank16[0], 0x8000);
        } else if ((address & 0xff) === 0x01) {
          this.prgBank16[1] = value & 0x0f;
          this.loadRomBank(this.prgBank16[1], 0xc000);
        }
        this.nes.papu.exWrite(address, value);
        break;

      case 0xa000:
        this.chrBank8k[1] = value & 0x0f;
        this.load8kVromBank(this.chrBank8k[1] * 2, 0x1000);
        break;

      default:
        // $B000-$FFFF is the YM2413. Nothing handles it, and papu.exWrite says so
        // by returning false rather than throwing, so a VRC7 game runs silent.
        this.nes.papu.exWrite(address, value);
        break;
    }
  };

  Mappers[85].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("VRC7: Invalid ROM! Unable to load.");
    }

    this.reset();
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.loadRomBank(0, 0x8000);
    this.loadRomBank(this.nes.rom.romCount - 1, 0xc000);
    this.resetIrqHandler();
  };

  Mappers[85].prototype.toJSON = function () {
    var s = Mappers[0].prototype.toJSON.apply(this);
    s.prgBank16 = this.prgBank16.slice();
    s.chrBank8k = this.chrBank8k.slice();
    return s;
  };

  Mappers[85].prototype.fromJSON = function (s) {
    Mappers[0].prototype.fromJSON.apply(this, arguments);
    this.prgBank16 = s.prgBank16.slice();
    this.chrBank8k = s.chrBank8k.slice();
    this.loadRomBank(this.prgBank16[0], 0x8000);
    this.loadRomBank(this.prgBank16[1], 0xc000);
    this.load8kVromBank(this.chrBank8k[0] * 2, 0x0000);
    this.load8kVromBank(this.chrBank8k[1] * 2, 0x1000);
  };
}

module.exports = { register: register };
